enum OrderContractSignatureRequired {
  BY_NONE = 'BY_NONE',
  BY_STORE = 'BY_STORE',
  BY_STORE_AND_BRAND = 'BY_STORE_AND_BRAND',
}

export default OrderContractSignatureRequired;
